/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Hero_Lede_CoachInputs */

const en_blog_hero_lede_coach = /** @type {(inputs: Blog_Hero_Lede_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programming, client care and running your own business, from people who coach for a living.`)
};

const pl_blog_hero_lede_coach = /** @type {(inputs: Blog_Hero_Lede_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programowanie treningu, opieka nad podopiecznymi i własna działalność, od ludzi, którzy z tego żyją.`)
};

/**
* | output |
* | --- |
* | "Programming, client care and running your own business, from people who coach for a living." |
*
* @param {Blog_Hero_Lede_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_hero_lede_coach = /** @type {((inputs?: Blog_Hero_Lede_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Hero_Lede_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_hero_lede_coach(inputs)
	return en_blog_hero_lede_coach(inputs)
});